<template>
	<div class="crowdx-about-section">
		<div class="container">
			<!-- Header section -->
			<div class="row">
				<div class="col-12">
					<h1 class="section-title headline-l">
						{{ $t('crowdxScreen.about.title') }}
					</h1>

					<div class="description-wrapper">
						<span
							class="top-text text-l section-description first-description"
							>{{ $t('crowdxScreen.about.descriptionFirstSection') }}</span
						>
						<span class="top-text text-l section-description">{{
							$t('crowdxScreen.about.description')
						}}</span>
					</div>
				</div>
			</div>

			<!-- Cards section -->
			<div class="cards-row">
				<div v-for="(card, index) in cards" :key="index" class="card-item">
					<div class="card-content">
						{{ card }}
					</div>
				</div>
			</div>

			<!-- Bottom description -->
			<!-- 			<div class="row">
				<div class="col-12">
					<div class="bottom-description text-l">
						{{ $t('crowdxScreen.about.bottomDescription') }}
					</div>
				</div>
			</div> -->
		</div>
	</div>
</template>

<script>
export default {
	name: 'CrowdxAboutSection',
	props: {
		customCards: {
			type: Array,
			required: false,
			default: null,
		},
	},
	components: {},
	data: () => ({}),
	created() {},
	computed: {
		cards() {
			if (this.customCards) {
				return this.customCards;
			}
			return [
				this.$t('crowdxScreen.about.cards.card1'),
				this.$t('crowdxScreen.about.cards.card2'),
				this.$t('crowdxScreen.about.cards.card3'),
				this.$t('crowdxScreen.about.cards.card4'),
				this.$t('crowdxScreen.about.cards.card5'),
			];
		},
	},
	methods: {},
};
</script>

<style lang="scss" scoped>
.crowdx-about-section {
	background-color: #ffffff;
	padding: 70px 0;
	margin: 0;

	@media (max-width: $breakpoint-sm) {
		padding: 60px 0;
	}

	.section-title {
		color: #26262b;
		text-align: center;
		margin-bottom: 40px;
		text-transform: uppercase;

		@media (max-width: $breakpoint-sm) {
			font-size: 34px;
			margin-bottom: 30px;
		}
	}

	.description-wrapper {
		text-align: center;
		max-width: 1050px;
		margin: 0 auto 60px;
		line-height: 1.6;
	}

	.top-text {
		display: inline;
	}

	.first-description {
		font-family: 'HKNova-Bold', sans-serif;
	}

	.section-description {
		color: #26262b;

		@media (max-width: $breakpoint-sm) {
			font-size: 16px;
		}
	}

	.cards-row {
		display: flex;
		flex-wrap: wrap;
		justify-content: center;
		gap: 30px;
	}

	.card-item {
		min-width: 350px;
		max-width: 450px;

		@media (max-width: $breakpoint-lg) {
			flex: 0 1 calc(50% - 15px);
			max-width: calc(50% - 15px);
		}

		@media (max-width: $breakpoint-sm) {
			flex: 0 1 100%;
			max-width: 100%;
		}

		.card-content {
			font-family: 'HKNova-Light', sans-serif;
			font-size: 16px;
			line-height: 24px;
			display: flex;
			align-items: center;
			justify-content: center;

			width: 100%;
			min-height: 80px;

			padding-left: 15px;
			padding-right: 15px;

			background: linear-gradient(90deg, #ed853200 0%, #fff1e6 100%);
			border: 1px solid #ed8532;
			border-radius: 0px;
			box-shadow: 0px 6px 20px rgba(0, 0, 0, 0.06);
			text-align: center;
		}
	}

	.bottom-description {
		color: #26262b;
		text-align: center;
		line-height: 1.6;
		max-width: 1050px;
		margin: 0 auto;

		@media (max-width: $breakpoint-sm) {
			font-size: 16px;
		}
	}
}
</style>
